import React from "react";
import { Camera, Clapperboard, Plane, Monitor } from "lucide-react";
import { Reveal, Label, Star } from "./primitives";

const HIGHLIGHTS = [
  { icon: Camera, label: "Photography" },
  { icon: Clapperboard, label: "Videography" },
  { icon: Plane, label: "Drone Footage" },
  { icon: Monitor, label: "Web & Social Media" },
];

export default function Stats() {
  return (
    <section className="relative z-10 py-24 md:py-32 border-y hairline overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal><Label>What we create</Label></Reveal>
        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#D4A843]/15 border hairline">
          {HIGHLIGHTS.map((h, i) => {
            const Icon = h.icon;
            return (
              <Reveal key={h.label} delay={i * 0.08}>
                <div data-testid={`highlight-${i}`} className="group bg-[#0D1220] p-8 md:p-12 h-full flex flex-col gap-6 hover:bg-white/[0.02] transition-colors duration-500">
                  <div className="flex items-center justify-between">
                    <Icon strokeWidth={1} className="w-9 h-9 md:w-11 md:h-11 text-gold transition-transform duration-500 group-hover:-translate-y-1" />
                    <Star size={11} className="text-gold/50" />
                  </div>
                  <p className="font-serif text-2xl md:text-3xl font-[300]">{h.label}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
